var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.alignment }, [
    _c(
      "h1",
      {
        staticClass: "heading black",
        class: _vm.headingClass,
        style: _vm.color,
      },
      [_vm._v(_vm._s(_vm.title))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }